<template>
  <div>
    <canvas id="bar-chart-chat-source" height="400"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "BarChartChatSource",
  props: {
    data: {
      type: Array,
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true,
    },
    maxValue: {
      type: Number,
      require: false,
      default: 0,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "name",
          yAxisKey: "count",
        },
        layout: {
          padding: 0,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                if (value % 1 === 0) {
                  return value;
                }
              },
            },
            suggestedMax: this.maxValue,
            title: {
              display: true,
              align: "center",
              text: "Number of Chat",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            grid: {
              drawOnChartArea: false,
            },
            stacked: true,
            beginAtZero: true,
            title: {
              display: true,
              align: "center",
              // text: this.yAxisTitle,
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 0 },
            },
          },
        },
        plugins: {
          datalabels: {
            display: (context) => {
              const index = context.dataIndex;
              const isShow = context.dataset.data[index];
              return isShow ? "auto" : false;
            },
            textAlign: "top",
            anchor: "end",
            align: "top",
            offset: -5,
            font: {
              size: 12,
            },
            formatter: (value, context) => {
              let data = this.addCommas(value);
              return data;
            },
          },
          legend: {
            display: true,
            position: "bottom",
            labels: { boxWidth: 10, boxHeight: 10 },
          },
          tooltip: {
            bodyAlign: "center",
            yAlign: "bottom",
            titleColor: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            titleMarginBottom: 0,
            padding: 12,
            callbacks: {
              title: (context) => {
                return;
              },
              label: (context) => {
                const contextElement = context;
                const labelCollect = [];
                const label = contextElement.label;
                const index = contextElement.datasetIndex;
                const dataFormated = contextElement.dataset.data[index];
                const unit = "Chats";
                let result = this.addCommas(dataFormated);
                labelCollect.push(` ${label}: ${result} ${unit}`);

                return [labelCollect].join("\n");
              },
              afterLabel: (context) => {
                return;
              },
            },
          },
        },
      },
    };
  },
  async mounted() {
    const ctx = document
      .getElementById("bar-chart-chat-source")
      .getContext("2d");
    let backgroundColor = [];
    let datasets = [];
    let labels = [];
    let count = this.data.length;
    await this.data.forEach((e, i) => {
      let color = "#7160C4";
      if (e.id == 1) color = "#39CD00";
      else if (e.id == 2) color = "#00A1F5";
      else if (e.id == 4) color = "#1976D2";
      else if (e.id == 5) color = "#CE3A9B";
      else if (e.id == 10) color = "#3f51b5";

      backgroundColor.push(color);
      labels.push(e.name);
      let data = new Array(count);
      data[i] = e.count;
      datasets.push({
        backgroundColor: color,
        label: e.name,
        type: "bar",
        data: data,
        borderRadius: {
          bottomLeft: 0,
          bottomRight: 0,
          topLeft: 5,
          topRight: 5,
        },
      });
    });

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: labels,
        datasets: datasets,
      },
      plugins: [ChartDataLabels],
      options: this.options,
    });
  },
  methods: {
    addCommas(nStr) {
      var x, x1, x2;

      nStr += "";
      x = nStr.split(".");
      x1 = x[0];
      x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
  },
};
</script>
